import styled from "styled-components";
import React from "react";

export function Table(props: { tableHeader: string[]; tableRows: string[][] }) {
    const { tableHeader, tableRows } = props;
    return (
        <StyledTable>
            <tr>
                {tableHeader.map((header: string) => (
                    <StyledTableHeaderElement>
                        {header}
                    </StyledTableHeaderElement>
                ))}
            </tr>
            {tableRows.map((row: string[]) => (
                <tr>
                    {row.map((rowElement: string) => (
                        <StyleTableRowElement>
                            {rowElement}
                        </StyleTableRowElement>
                    ))}
                </tr>
            ))}
        </StyledTable>
    );
}

const StyledTable = styled.table`
    font-weight: 300;
    text-align: center;
    margin-right: auto;
    margin-left: auto;
    border: solid 5px;
    color: white;
    border-color: #000e6f;
    border-spacing: 5px;
    border-radius: 5px;
    opacity: 0.8;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);
    background-color: #000e6f;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.8);
`;

const StyledTableHeaderElement = styled.th``;

const StyleTableRowElement = styled.td``;
